<template>
  <v-row class="c-patient-test-summary pa-8">
    <v-col
      cols="6"
      align="center"
      align-self="center"
      v-for="(singleSummary, index) in this.$props.patientTestSummary"
      v-bind:key="singleSummary.groupKey0"
      class="c-patient-test-summary__col"
    >
      <span class="mr-1">{{ index + 1 }}.</span>
      <category-icon
        :categoryKey="singleSummary.groupKey0"
        class="inline-block"
        :size="24"
        :iconColor="$props.levelColor"
      />
      <span>{{ decimalToPercentage(singleSummary.scorePercent) }}%</span>
    </v-col>
  </v-row>
</template>

<script>
import CategoryIcon from './CategoryIcon.vue';

/**
 * Component PatientTestSummary.vue
 *
 * @module PatientTestSummary
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.8] app/src/APP_DASHBOARD/templates/components/Parts/PatientTestSummary.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "PatientTestSummary",
  components: { CategoryIcon },
  props: {
    patientTestSummary: {
      type: Array,
    },
    levelColor: {
      type: String,
      default: () => 'rgba(0, 0, 0, 0.87)'
    },
  },
  methods: {
    decimalToPercentage(value) {
      return (value * 100).toFixed(0).replace(/\.00$/, '')
    }
  }
};
</script>

<style lang="scss">
@import "../../../../scss/colors";
.c-patient-test-summary {
  .c-patient-test-summary__col {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid map-get($coroColors, lightgray2);
    margin-top: 16px;
    font-weight: 500;
    font-size: 1rem;

    i, svg {
      margin-right: 8px;
    }
  }
}
</style>